import { Injectable } from '@angular/core';
import { FluxStandardAction } from 'flux-standard-action';
import { Role, UserRoles } from './user-role-state.model';
export type Action = FluxStandardAction<any, any>;

@Injectable()
export class UserRoleActions {
  /**
   * @arg Declaration of the action to set update atributes
   **/
  static readonly SET_UPDATE = 'SET_UPDATE';
  /**
   * @arg Declaration reset update attribues
   **/
  static readonly RESET_UPDATE = 'RESET_UPDATE';
  /**
   * @method setUpdateInfo Store the update info
   * @param updateRole indicate user role updation
   * @param userRoles User role
   * @param roleList list of all roles
   * @return void
   **/
  static setUpdateInfo(
    updateRole: string,
    userRoles: UserRoles,
    roleList: Array<Role>
  ) {
    return {
      type: UserRoleActions.SET_UPDATE,
      payload: { updateRole, userRoles, roleList },
    };
  }
  /**
   * @method resetUpdate reset the update info
   * @return void
   **/
  static resetUpdate() {
    return {
      type: UserRoleActions.RESET_UPDATE,
      payload: {},
    };
  }
}
